/* eslint-disable no-extra-boolean-cast */
import React, { useMemo, useState, useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  Modal,
  Button,
  Checkbox,
  DatePicker,
  Form,
  Select,
  Space,
  Tooltip,
  Upload,
  Row,
  Input
} from "antd";
import { Flex, TimePicker } from "antd-v5";

/* import { Editor } from "../Editor/index" */

import TextArea from "antd/lib/input/TextArea";
import { LoadingOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import _ from "lodash";
import DropdownIcon from "../DropdownIcon/DropdownIcon";
import Trash from "../../assets/svg/trash";
import { getCities, getCountries } from "../../store/resourcesSlice";
import {
  backendUrl,
  draftsAPI,
  exhibitionAPI,
  mediaUrl,
  PRODUCTION_URL,
  resourcesAPI,
  TINY_MCE_API_KEY,
  uploadsAPI
} from "../../api/api";
import { Link, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { meetingApi } from "../../api";
import { DebounceSearchSelect, SimpleSelect, styles } from "Components/Search";

import s from "./create-exhibition-panel.module.less";
import useOnlyLatinLetterInputHandlerAndModal from "../../hooks/useOnlyLatinLetterInputHandlerAndModal";
import AutoCompleteCustom from "./AutoComplete/AutoComplete";
import {
  setExhibitionPanel,
  setExistExhibitionsArchive,
  setIsExistExhibitions,
  setSavedExhibition
} from "../../store/exhibitionSlice";
import axios from "axios";
import ImagePreview from "../ImagePreview/ImagePreview";
import { Editor } from "@tinymce/tinymce-react";
import { customKeyWordsValidator } from "../../helpers/validation-rules";
import { BannerPreview } from "../BannerPreview";
import { getDimensions } from "../../helpers/getDimensions";
import { countFormatter } from "../../helpers/counterFormat";
const { RangePicker } = DatePicker;
const dateFormat = "YYYY-MM-DD";

const modalTypes = {
  FINISH_EDITING: "FINISH_EDITING",
  UNKNOWN_ERROR: "UNKNOWN_ERROR",
  CREATION_SUCCESS: "CREATION_SUCCESS",
  WRONG_NEW_EXHIBITION_OR_EXHIBITION_ID: "WRONG_NEW_EXHIBITION_OR_EXHIBITION_ID",
  STAND_EXISTS: "STAND_EXISTS",
  NOT_FOUND_EXHIBITION: "NOT_FOUND_EXHIBITION",
  EXHIBITION_ALREADY: "EXHIBITION_ALREADY",
  NO_CORRECT_TIMES: "NO_CORRECT_TIMES",
  EMPTY_EXHIBITION: "EMPTY_EXHIBITION",
  SAVING_SUCCESS: "SAVING_SUCCESS",
  "На главной уже добавлено 3 мероприятия": "TOO_MANY_ON_MAIN"
};

const CreateExhibitionPanel = ({
  num = 1,
  showCreateExhibitionPanel,
  setShowCreateExhibitionPanel
}) => {
  const [openState, setOpenState] = useState(false);
  const [banners, setBanners] = useState([]);
  const { isEditMode, savedExhibition } = useSelector((state) => state.exhibitions);
  const { isAdmin, user } = useSelector((state) => state.auth);
  const { t } = useTranslation([
    "CreateExhibitionPanel",
    "Countries",
    "FS8-changeCompanyProfile",
    "FS100-MyExhibitions",
    "BA1-EditAndViewExhibition",
    "FA52A-Moderation-changes"
  ]);
  const { countries, cities: resourcesCities } = useSelector((state) => state.resources);
  const [errors, setErrors] = useState({
    passageDiagram: false,
    logo: false,
    description: false,
    mainPageDescriptionOrange: false,
    mainPageDescriptionGrey: false,
    keyProducts: false,
    boothNumber: false
  });
  const [checkboxError, setCheckboxError] = useState(false);
  const { lang } = useSelector((state) => state.auth);
  const [passageDiagram, setPassageDiagram] = useState("");
  const [logo, setLogo] = useState("");
  const [form] = Form.useForm();
  const [exhibition, setExhibition] = useState({});
  const [modalType, setModalType] = useState("");
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const uploadRef = useRef(null);
  const [isDisabled, setIsDisabled] = useState(false);
  // Exhibition the company is joining (already created by somebody else)
  const [joinedExhibition, setJoinedExhibition] = useState(null);
  const [newExhibitionName, setNewExhibitionName] = useState("");
  const [exhibitionName, setExhibitionName] = useState("");
  const [exhibitionId, setExhibitionId] = useState(null);
  const isPrivateCheckbox = Form.useWatch("isPrivate", form);
  const isVisibleCheckbox = Form.useWatch("isVisible", form);
  const currentCountryId = Form.useWatch("countryId", form);
  const [cities, setCities] = useState([]);

  const [isCreating, setIsCreating] = useState(true);

  const [initialValues, setInitialValues] = useState({});
  const [checkBoxSelected, setCheckboxSelected] = useState({
    isPrivate: isPrivateCheckbox || initialValues.isPrivate,
    isVisible: isVisibleCheckbox || initialValues.isVisible,
    isOnline: initialValues.isOnline,
    isOnMain: initialValues.isOnMain,
    isAutomaticBannerChange: initialValues.isAutomaticBannerChange
  });
  const [showErrorModal, setShowErrorModal] = useState(false);
  const { myExhibitions, existExhibitions, existExhibitionsArchive } = useSelector(
    (state) => state.exhibitions
  );
  const [validateCheckBox, setValidateCheckBox] = useState(false);
  const [modalText, setModalText] = useState("");
  const [imagePreviewOpen, setImagePreviewOpen] = useState(false);
  const [logoPreviewOpen, setLogoPreviewOpen] = useState(false);

  const exhibitionArciveMappedNameArray = existExhibitionsArchive.map(
    (archiveExhibition) => archiveExhibition.value
  );
  const exhibitionsMappedNameArray = existExhibitions?.map((exhibitions) => exhibitions.value);

  const exhibitionNameAnreadyExsist =
    (newExhibitionName && exhibitionsMappedNameArray.includes(newExhibitionName)) ||
    (!newExhibitionName && exhibitionsMappedNameArray.includes(initialValues.exhibitionName));

  const mainPageDescriptionGrey = Form.useWatch("mainPageDescriptionGrey", form);
  const mainPageDescriptionOrange = Form.useWatch("mainPageDescriptionOrange", form);

  const [times, setTimes] = useState({
    endDate: "",
    startDate: "",
    times: []
  });

  const myExhibitionsMapped = myExhibitions.items.map((obj) => obj.exhibitionName);

  const standAlreadyExsist =
    (newExhibitionName && myExhibitionsMapped.includes(newExhibitionName)) ||
    (!newExhibitionName && myExhibitionsMapped.includes(initialValues.exhibitionName));

  const scrollToFirstInvalidFiled = () => {
    setTimeout(() => {
      const firstInvalidField = document.querySelector(".ant-form-item-has-error");
      if (firstInvalidField) {
        firstInvalidField.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest"
        });
      }
    }, 100);
  };

  const isExhibitionOnline = useMemo(
    () => exhibition.exhibitionType === "online",
    [exhibition.exhibitionType]
  );

  useEffect(() => {
    if (!isAdmin && times.times.length > 0) {
      dispatch(setExhibitionPanel(true));
    } else {
      dispatch(setExhibitionPanel(false));
    }
  }, [times.times, isAdmin]);

  const formatDate = (date) => {
    return `${date.$y}-${(date.$M + 1).toString().padStart(2, "0")}-${date.$D
      .toString()
      .padStart(2, "0")}`;
  };

  const restoreData = async () => {
    console.log(savedExhibition);
    setIsCreating(savedExhibition?.isCreating);
    if (!savedExhibition?.isCreating) {
      setIsDisabled(true);
      setExhibitionId(savedExhibition?.exhibitionId);
    }
    const element = document.getElementById("create-exhibition");
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    setShowCreateExhibitionPanel(true);
    await handleCitiesSearch("", exhibition.countryId);
    onFinish(
      {
        ...savedExhibition.exhibition,
        customIsCreating: savedExhibition.isCreating,
        startDate: Array.isArray(savedExhibition.exhibition.startDate)
          ? [
              formatDate(savedExhibition.exhibition.startDate[0]),
              formatDate(savedExhibition.exhibition.startDate[1])
            ]
          : [
              formatDate(savedExhibition.exhibition.startDate),
              formatDate(savedExhibition.exhibition.endDate)
            ],
        onSuccess: () => {
          setPassageDiagram(savedExhibition.exhibition.passageDiagram);
          setLogo(savedExhibition.exhibition.logo);
          dispatch(setSavedExhibition(null));
          setShowCreateExhibitionPanel(true);
        },
        onError: () => {
          setIsCreating(false);
          dispatch(setSavedExhibition(null));
        },
        checkbox: {
          isPrivate: savedExhibition?.checkbox?.isPrivate,
          isVisible: savedExhibition?.checkbox?.isVisible,
          isOnline: savedExhibition?.checkbox?.isOnline,
          isAutomaticBannerChange: savedExhibition?.checkbox?.isAutomaticBannerChange,
          isOnMain: savedExhibition?.checkbox?.isOnMain
        }
      },
      savedExhibition.times
    );
  };
  useEffect(() => {
    if (!savedExhibition || savedExhibition?.type === "exists") return;
    setCheckboxSelected((prev) => ({
      ...prev,
      isPrivate: savedExhibition?.checkbox?.isPrivate,
      isVisible: savedExhibition?.checkbox?.isVisible,
      isOnline: savedExhibition?.checkbox?.isOnline,
      isAutomaticBannerChange: savedExhibition?.checkbox?.isAutomaticBannerChange,
      isOnMain: savedExhibition?.checkbox?.isOnMain
    }));
    restoreData();
  }, [savedExhibition]);

  const getCitiesOnChange = async () => {
    const response = await handleCitiesSearch("", currentCountryId);
    response && setCities(response.data);
  };

  useEffect(() => {
    if (!currentCountryId) return;
    getCitiesOnChange();
  }, [currentCountryId]);

  console.log(banners);

  const getDraft = async () => {
    if (!isAdmin && showCreateExhibitionPanel) {
      const qParams = {
        companyId: user.company?.id,
        entityType: "exhibition"
      };
      try {
        const { data } = await draftsAPI.getDraft(qParams);
        const passageDiagram = data?.stand?.passageDiagram;
        const draftLogo = data?.logo;
        const { stand } = data;
        let exhibition = {};
        if (data.exhibitionId) {
          exhibition = (await exhibitionAPI.getExhibitionById(data.exhibitionId)).data;
          setExhibitionId(data.exhibitionId);
          setIsDisabled(true);
          setIsCreating(false);
          setJoinedExhibition(exhibition);
        } else {
          const { newExhibition } = data;
          exhibition = newExhibition;
          setJoinedExhibition(null);
        }
        setPassageDiagram(passageDiagram);
        setLogo(draftLogo);
        const response = await handleCitiesSearch(
          "",
          data?.countryId || data?.newExhibition?.countryId
        );
        response && setCities(response.data);
        const formValues = {
          exhibitionName: exhibition?.exhibitionName,
          website: exhibition?.website,
          logo: exhibition?.logo,
          countryId: exhibition?.countryId,
          cityId: exhibition?.cityId,
          areaName: exhibition?.areaName,
          startDate: [
            exhibition?.startDate ? dayjs(exhibition?.startDate) : "",
            exhibition?.endDate ? dayjs(exhibition?.endDate) : ""
          ],
          isPrivate: !!exhibition?.isPrivate,
          isOnline: isExhibitionOnline,
          isAutomaticBannerChange: !!exhibition?.isAutomaticBannerChange,
          isOnMain: !!exhibition?.isOnMain,
          boothNumber: stand?.boothNumber,
          organizerName: exhibition?.organizerName || stand?.organizerName,
          description: stand?.description,
          mainPageDescriptionOrange: stand?.mainPageDescriptionOrange,
          participationDescription: stand?.participationDescription,
          mainPageDescriptionGrey: stand?.mainPageDescriptionGrey,
          keyProducts: exhibition?.keyProducts || stand?.keyProducts,
          isVisible: !!stand?.isVisible,
          statsConfirmedMeetings: exhibition?.statsConfirmedMeetings,
          statsUnconfirmedMeetings: exhibition?.statsUnconfirmedMeetings
        };
        setInitialValues(formValues);
        setExhibitionName(formValues.exhibitionName);
        if (exhibition?.startDate && exhibition?.endDate) {
          setTimes((prev) => ({
            ...prev,
            startDate: dayjs(dayjs(exhibition?.startDate).format(dateFormat)),
            endDate: dayjs(dayjs(exhibition?.endDate).format(dateFormat)),
            times: calcDaysWorkingTimeArr(
              exhibition?.startDate,
              exhibition?.endDate,
              exhibition?.times
            )
          }));
        }
        setNewExhibitionName(exhibition?.exhibitionName);

        if (exhibition?.times) {
          exhibition.times.forEach((el, i) => {
            form.setFieldsValue({
              [`rangePicker_${i}`]: [dayjs(el.startDate), dayjs(el.endDate)]
            });
          });
        }
        if (stand?.passageDiagram) {
          setPassageDiagram(stand?.passageDiagram);
        }
        if (exhibition?.logo) {
          setLogo(exhibition?.logo);
        }
        form.setFieldsValue({ isVisible: !!formValues.isVisible });
        form.setFieldsValue({ isPrivate: !!formValues.isPrivate });
        form.setFieldsValue({ isOnline: !!formValues.isOnline });
        form.setFieldsValue({ isAutomaticBannerChange: !!formValues.isAutomaticBannerChange });
        form.setFieldsValue({ isOnMain: !!formValues.isOnMain });
        form.setFieldsValue({ boothNumber: formValues.boothNumber });
        form.setFieldsValue({ ...formValues });
        setShowCreateExhibitionPanel(true);
      } catch (error) {
        throw new Error(error);
      }
    }
  };
  console.log(savedExhibition);
  useEffect(() => {
    if (formRef.current && form.__INTERNAL__.name && !savedExhibition) getDraft();
  }, [showCreateExhibitionPanel, savedExhibition]);

  useEffect(() => {
    if (initialValues.isPrivate || initialValues.isVisible || initialValues.isOnline) {
      setCheckboxSelected((prev) => ({
        ...prev,
        isPrivate: initialValues.isPrivate,
        isVisible: initialValues.isVisible,
        isOnline: initialValues.isOnline,
        isAutomaticBannerChange: initialValues.isAutomaticBannerChange,
        isOnMain: initialValues.isOnMain
      }));
    }
  }, [
    initialValues.isPrivate,
    initialValues.isVisible,
    initialValues.isOnline,
    initialValues.isAutomaticBannerChange,
    initialValues.isOnMain
  ]);

  useEffect(() => {
    if (newExhibitionName !== exhibitionName && !exhibitionId) {
      setIsDisabled(false);
      setExhibitionId(null);
      setJoinedExhibition(null);
    }
  }, [newExhibitionName, exhibitionName]);

  const clearImage = (event, type = "passageDiagram", file) => {
    if (type === "passageDiagram") {
      setPassageDiagram("");
    } else if (type === "banners") {
      const banners = form.getFieldValue("banners") || [];
      setBanners((prev) => prev.filter((item) => item.name !== file.name));
      form.setFieldsValue({ banners: banners.filter((item) => item !== file.name) });
    }
  };
  const clearLogoImage = () => {
    setLogo("");
  };

  useEffect(() => {
    if (exhibitionName) {
      setNewExhibitionName(exhibitionName);
    }
  }, [exhibitionName]);

  const handleResetForm = () => {
    const formFields = Object.keys(form.getFieldValue());
    formFields.forEach((fieldName) => {
      form.setFieldsValue({ [fieldName]: undefined });
    });
  };

  const clearForm = () => {
    form.resetFields();
    handleResetForm();
    setExhibition({});
    setJoinedExhibition(null);
    setBanners([]);
    setTimes({
      endDate: "",
      startDate: "",
      times: []
    });
    form.setFieldsValue({ mainPageDescriptionGrey: "", mainPageDescriptionOrange: "" });
    setLogo("");
  };

  const deleteDraft = async () => {
    try {
      await exhibitionAPI.createExhibition({
        sendModeration: false
      });
    } catch (error) {
      throw new Error(error);
    }
  };

  const clearError = (fieldName) => form.setFields([{ name: fieldName, errors: [] }]);

  useEffect(() => {
    if (!countries.length) {
      dispatch(getCountries());
    }
    if (!resourcesCities.length) {
      dispatch(getCities());
    }
  }, []);

  // Организатор — свойство самой выставки: компания, присоединяющаяся к чужой выставке,
  // только видит его, а редактировать может лишь создатель выставки и администраторы.
  const canEditOrganizerName = useMemo(() => {
    if (isAdmin) return true;
    if (!joinedExhibition) return true;
    if (joinedExhibition.creatorType !== "company") return false;
    const creatorCompanyId = joinedExhibition.creatorId || joinedExhibition.creator?.id;
    return !!creatorCompanyId && creatorCompanyId === user?.company?.id;
  }, [isAdmin, joinedExhibition, user]);

  const citiesOptions = useMemo(
    () =>
      cities.map(({ id, localizedName }) => ({
        label: localizedName[lang],
        value: id
      })),
    [cities, lang]
  );

  useMemo(() => {
    const {
      exhibitionName,
      website,
      country,
      cityId,
      areaName,
      endDate,
      startDate,
      description,
      keyProducts,
      participationDescription,
      mainPageDescriptionOrange,
      mainPageDescriptionGrey,
      organizerName,
      times,
      id
    } = exhibition;
    if (formRef.current && form.__INTERNAL__.name) {
      if (!_.isEmpty(exhibition)) {
        setExhibitionId(id);
        setNewExhibitionName(exhibitionName);
        setIsDisabled(true);
        form.setFieldsValue({
          website,
          cityId,
          areaName,
          countryId: country?.id,
          exhibitionName,
          startDate: [
            dayjs(dayjs(startDate).format(dateFormat), dateFormat),
            dayjs(dayjs(endDate).format(dateFormat), dateFormat)
          ],
          description,
          mainPageDescriptionOrange,
          participationDescription,
          keyProducts,
          mainPageDescriptionGrey,
          organizerName,
          isPrivate: !!exhibition?.isPrivate,
          isVisible: !exhibition?.isPrivate,
          isOnline: isExhibitionOnline,
          isAutomaticBannerChange: !!exhibition?.isAutomaticBannerChange,
          isOnMain: !!exhibition?.isOnMain
        });
        setCheckboxSelected((prevState) => ({
          ...prevState,
          isVisible: !exhibition?.isPrivate,
          isPrivate: !!exhibition?.isPrivate,
          isOnline: isExhibitionOnline,
          isAutomaticBannerChange: !!exhibition?.isAutomaticBannerChange,
          isOnMain: !!exhibition?.isOnMain
        }));
        form.setFieldsValue({ website: website });
        if (startDate && endDate) {
          setTimes((prev) => ({
            ...prev,
            startDate: dayjs(dayjs(startDate).format(dateFormat)),
            endDate: dayjs(dayjs(endDate).format(dateFormat)),
            times: calcDaysWorkingTimeArr(startDate, endDate, times)
          }));
        }

        if (times) {
          times.forEach((_, i) => {
            form.setFieldsValue({
              [`rangePicker_${i}`]: [
                dayjs(dayjs(times.startDate).format("YYYY-MM-DD 10:00")),
                dayjs(dayjs(times.endDate).format("YYYY-MM-DD 18:00"))
              ]
            });
          });
        }
      } else {
        setIsDisabled(false);
      }
    }
  }, [exhibition, formRef, form]);

  const handleErrors = (errorFields) => {
    errorFields?.forEach(({ name }) => {
      const errorField = name[name.length - 1];
      setErrors((prevErrors) => {
        return { ...prevErrors, [errorField]: true };
      });
    });
  };

  function clearAllErrors(arr) {
    const errorFieldsNames = arr.map(({ name }) => {
      if (name.length === 1) {
        return `${name[0]}`;
      } else if (name.length === 2) {
        return `${name[0]}.${name[1]}`;
      }
      return "";
    });
    form.resetFields(errorFieldsNames);
  }

  const normalizeExhibitionData = (exhibition) => {
    const exhibitionName = exhibition.exhibitionName;
    const startDate = exhibition.startDate[0];
    const endDate = exhibition.startDate[1];
    const date1 = dayjs(startDate);
    const date2 = dayjs(endDate);
    const daysCount = date2.diff(date1, "day");

    const extractedRangePickerArray = [];
    for (const key in exhibition) {
      if (key.includes("rangePicker")) {
        extractedRangePickerArray.push(exhibition[key]);
      }
    }

    function formatTime(date) {
      return dayjs(date.$d).format("HH:mm");
    }

    const formattedTimeArray = extractedRangePickerArray.map((nestedArray) => {
      const startTime = formatTime(nestedArray[0]);
      const endTime = formatTime(nestedArray[1]);
      return { startTime, endTime };
    });

    const workingHours = Array.from({ length: daysCount + 1 }, (_, i) => {
      return {
        startDate: date1.add(i, "day").format("DD.MM.YYYY"),
        timeRange: formattedTimeArray
      };
    });

    const newObj = {
      exhibitionName,
      website: exhibition.website,
      countryId: exhibition.countryId,
      cityId: exhibition.cityId,
      areaName: exhibition.areaName,
      startDate: dayjs(exhibition.startDate[0]).format("DD-MM-YYYY"),
      endDate: dayjs(exhibition.startDate[1]).format("DD-MM-YYYY"),
      times: workingHours,
      isPrivate: exhibition.isPrivate ? true : false,
      exhibitionType: checkBoxSelected?.isOnline || isExhibitionOnline ? "online" : "offline",
      isAutomaticBannerChange:
        checkBoxSelected?.isAutomaticBannerChange || exhibition.isAutomaticBannerChange,
      isOnMain: checkBoxSelected?.isOnMain || exhibition.isOnMain,
      logo: logo,
      organizerName: exhibition.organizerName,
      stand: {
        isVisible: exhibition.isVisible ? true : false,
        passageDiagram: passageDiagram,
        boothNumber: exhibition.boothNumber,
        description: exhibition.description,
        mainPageDescriptionOrange: exhibition.mainPageDescriptionOrange,
        participationDescription: exhibition.participationDescription,
        mainPageDescriptionGrey: exhibition.mainPageDescriptionGrey,
        keyProducts: exhibition.keyProducts
      }
    };
    if (exhibitionId) newObj.id = exhibitionId;

    return newObj;
  };

  const onFinish = async (
    {
      onSuccess,
      onError,
      customIsCreating = null,
      stand,
      description,
      mainPageDescriptionOrange,
      mainPageDescriptionGrey,
      participationDescription,
      boothNumber,
      organizerName,
      areaName,
      keyProducts,
      cityId,
      logo: finalLogo,
      countryId,
      banners: exhibitionBanners,
      website,
      exhibitionName,
      startDate,
      endDate,
      checkbox,
      ...rest
    },
    customTimes
  ) => {
    console.log("3333");
    const isFree = exhibitionName ? await isExhibitionNameFree(exhibitionName) : true;
    const exhibitionTimes = customTimes;
    console.log(isFree, customIsCreating, isCreating);
    if (!isFree && (customIsCreating !== null ? customIsCreating : isCreating)) {
      setModalText(t("infoModal.errorExhibitionAlreadyExist"));
      setShowErrorModal(true);
      form.setFieldsValue({ exhibitionName: "" });
    } else {
      let sendData = {
        sendModeration: !!isAdmin
      };
      const dataPassageDiagram = `${rest.passageDiagram}`;
      delete rest.passageDiagram;
      delete rest.isVisible;
      delete rest.isPrivate;
      delete rest.isOnline;
      delete rest.isAutomaticBannerChange;
      delete rest.isOnMain;
      delete rest.mainPageDescriptionOrange;
      delete rest.mainPageDescriptionGrey;
      delete rest.description;
      delete rest.keyProducts;
      delete rest.banners;

      let exhibition = {};
      let standData = _.omitBy(stand, _.isNil());
      if (exhibitionTimes?.times?.length) {
        /*  exhibition.times = Object.keys(rest).map((key) => ({
          startTime: dayjs(rest[key][0]).format("HH:mm"),

          endTime: dayjs(rest[key][1]).format("HH:mm")
        }));
        Object.keys(rest).map((key) => {
          console.log(dayjs(rest[key][0]).format("HH:mm"), key, key[0]?.format);
        }); */
        exhibition.times = exhibitionTimes.times.map((value) => {
          return {
            startTime: value.startTime,
            endTime: value.endTime
          };
        });
      } else {
        exhibition.times = Object.keys(rest).map((key) => {
          const timesStartDate = rest[key][0];
          const timesEndDate = rest[key][1];
          console.log(rest);
          const formatTime = (date) => {
            if (date?.format) {
              return dayjs(date).format("HH:mm");
            } else {
              // Use $H and $m properties to construct the time string
              return `${date.$H?.toString()?.padStart(2, "0")}:${date.$m
                ?.toString()
                ?.padStart(2, "0")}`;
            }
          };

          return {
            startTime: formatTime(timesStartDate),
            endTime: formatTime(timesEndDate)
          };
        });
      }
      console.log(startDate, customTimes, times);

      if (Array.isArray(startDate) && startDate[0] && startDate[1]) {
        exhibition.startDate = dayjs(startDate[0]).format(dateFormat);
        exhibition.endDate = dayjs(startDate[1]).format(dateFormat);
      }

      if (
        passageDiagram?.length ||
        (dataPassageDiagram?.length && dataPassageDiagram !== "undefined")
      ) {
        standData["passageDiagram"] = passageDiagram || dataPassageDiagram;
      } else {
        standData["passageDiagram"] = "";
      }
      sendData = {
        newExhibition: {
          ...exhibition,
          description,
          mainPageDescriptionOrange,
          mainPageDescriptionGrey,
          areaName,
          cityId,
          countryId,
          website,
          exhibitionName,
          banners: exhibitionBanners,
          logo: finalLogo || logo,
          isPrivate: checkbox ? checkbox?.isPrivate : checkBoxSelected.isPrivate,
          isAutomaticBannerChange:
            checkbox?.isAutomaticBannerChange ||
            checkBoxSelected?.isAutomaticBannerChange ||
            exhibition.isAutomaticBannerChange,
          isOnMain: checkbox?.isOnMain || checkBoxSelected?.isOnMain || exhibition.isOnMain,
          organizerName,
          exhibitionType:
            checkbox?.isOnline || checkBoxSelected?.isOnline || isExhibitionOnline
              ? "online"
              : "offline"
        },
        stand: {
          ...standData,
          description,
          mainPageDescriptionOrange: mainPageDescriptionOrange,
          mainPageDescriptionGrey: mainPageDescriptionGrey,
          boothNumber,
          participationDescription,
          keyProducts,
          isVisible: checkbox ? checkbox?.isVisible : checkBoxSelected.isVisible
        },
        sendModeration: !!isAdmin
      };

      sendData.newExhibition = _(sendData.newExhibition)
        .omitBy(_.isUndefined)
        .omitBy(_.isNull)
        .value();
      sendData.stand = _(sendData.stand).omitBy(_.isUndefined).omitBy(_.isNull).value();

      if ((newExhibitionName === exhibition?.exhibitionName || exhibitionId) && exhibitionId) {
        delete sendData.newExhibition;
        sendData.exhibitionId = exhibitionId;
      } else {
        exhibition.exhibitionName = exhibitionName;
      }
      if (isAdmin) {
        sendData.newExhibition.isPrivate = false;
      }

      if (isAdmin) {
        delete sendData.stand;
      }

      const isNewExhibitionEmpty = _.isEmpty(sendData.newExhibition);
      const isStandEmpty = _.isEmpty(sendData.stand);

      if (!isAdmin && isNewExhibitionEmpty && isStandEmpty) {
        deleteDraft();
      } else {
        try {
          await exhibitionAPI.createExhibition({ ...sendData });
          getDraft();
          handleOpenModal(modalTypes.SAVING_SUCCESS);
          console.log("d");
          onSuccess && onSuccess();
          if (isAdmin) clearForm();
        } catch ({ response }) {
          const { message: errorMessage } = response.data;
          console.log(errorMessage, "test");
          handleOpenModal(modalTypes[errorMessage]);
          onError && onError();
        }
      }
    }
  };

  const closeImagePreview = () => setImagePreviewOpen(false);
  const openImagePreview = () => setImagePreviewOpen(true);

  const closeLogoPreview = () => setLogoPreviewOpen(false);
  const openLogoPreview = () => setLogoPreviewOpen(true);

  const handleExhibitionSelect = useCallback(async (_, { key }) => {
    try {
      const { data } = await exhibitionAPI.getExhibitionById(key);
      if (data.isPrivate) {
        handleOpenModal("isPrivate");
        setExhibitionName(" ");
      } else if (data.isArchive) {
        handleOpenModal("isArchive");
        setExhibitionName(" ");
      } else if (data.onModeration) {
        handleOpenModal("onModeration");
        setExhibitionName("baba");
      } else {
        const response = await handleCitiesSearch("", data.countryId);
        setCities(response.data);
        setExhibition(data);
        setJoinedExhibition(data);
        data?.logo && setLogo(data?.logo);
        setIsCreating(false);
      }
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const beforeUpload = async (file, type, fileList) => {
    if (type === "banners" && (banners.length === 3 || file.size / 1024 > 1024)) {
      return false;
    } else if (type === "banners") {
      const dimensions = await getDimensions(file);
      if (dimensions.width > 1454 || dimensions.height > 259) {
        setErrors((prev) => ({
          ...prev,
          ...(type ? { [type]: true } : {})
        }));
        return false;
      }
    }
    if (file.size / 1024 > 5024) {
      setErrors((prev) => ({
        ...prev,
        ...(type ? { [type]: true } : {})
      }));
      return false;
    } else {
      setErrors((prev) => ({
        ...prev,
        ...(type ? { [type]: false } : {})
      }));
    }
  };

  const beforeLogoUpload = (file) => {
    if (file.size / 1024 > 5024) {
      clearLogoImage();
      setErrors((prev) => ({
        ...prev,
        logo: true
      }));
      return false;
    }
    if (errors.logo) {
      setErrors((prev) => ({
        ...prev,
        logo: false
      }));
    }
  };

  const isExhibitionNameFree = async (exhibitionName) => {
    try {
      let data = await axios
        .get(`${backendUrl}/exhibitions/search?exhibitionName=${exhibitionName}&all=true`)
        .then(({ data }) => data);

      const isThereExhibitionName = data.some((item) => item.exhibitionName === exhibitionName);
      return !isThereExhibitionName;
    } catch (error) {
      throw new Error(error);
    }
  };

  const uploadImg = async (data, type) => {
    const formData = new FormData();
    formData.append("file", data.file, data.file.type.replace("/", "."));
    formData.append("originalname", data.file.name);
    const uploadedImage = await (await uploadsAPI.uploadImage(formData)).data.filename;
    setPassageDiagram(uploadedImage);
    if (type === "passageDiagram") {
      setPassageDiagram(uploadedImage);
    } else if (type === "banners") {
      const banners = form.getFieldValue("banners") || [];
      form.setFieldsValue({ banners: [...banners, uploadedImage] });
      console.log(form.getFieldValue([]), { banners: [...banners, uploadedImage] });
      setBanners((prev) => [
        ...prev,
        { name: uploadedImage, status: "done", thumbUrl: mediaUrl + uploadedImage }
      ]);
    }
  };

  const handleEditorChange = (content, editor, fieldName) => {
    const text = editor.getContent({ format: "text" });
    setErrors((prev) => ({ ...prev, mainPageDescriptionOrange: false }));
    clearError(fieldName);
    OnlyLatinLettersTextInput(
      text,
      fieldName,
      form,
      true,
      null,
      null,
      true,
      () => {
        form.setFieldsValue({
          [fieldName]: content
        });
      },
      true
    );
  };

  const uploadLogo = async (data) => {
    const formData = new FormData();
    formData.append("file", data.file, data.file.type.replace("/", "."));
    formData.append("originalname", data.file.name);
    const uploadedImage = await (await uploadsAPI.uploadImage(formData)).data.filename;
    setLogo(uploadedImage);
  };

  const normalizeFile = (event) => {
    if (Array.isArray(event)) {
      return event;
    }
    return event && event.fileList;
  };

  const onWorkingTimeChange = (val, index) => {
    console.log(val, "val");
    setTimes((prev) => {
      return {
        ...prev,
        times: prev.times.map((el, i) => {
          if (i === index) {
            return {
              ...el,
              startTime: val?.[0] ? val[0].format("HH:mm") : undefined,
              endTime: val?.[1] ? val[1].format("HH:mm") : undefined,
              timeRange: val
            };
          } else {
            return el;
          }
        })
      };
    });
  };
  const onEndDateChange = (val) => {
    const date = val[0] ? dayjs(val[0].$d).format(dateFormat) : undefined;
    setTimes((prev) => ({
      ...prev,
      endDate: date,
      times: calcDaysWorkingTimeArr(prev.startDate, date, prev.times)
    }));
    clearError("endDate");
  };
  const onStartDateChange = (val) => {
    const date = val[0] ? dayjs(val[0].$d).format(dateFormat) : undefined;
    const endDate = val[1] ? dayjs(val[1].$d).format(dateFormat) : undefined;
    setTimes((prev) => {
      return {
        ...prev,
        startDate: date ? date : prev.startDate,
        endDate: endDate ? endDate : prev.endDate,
        times: calcDaysWorkingTimeArr(
          date ? date : prev.startDate,
          endDate ? endDate : prev.endDate,
          prev.times
        )
      };
    });
  };

  console.log(times);
  /* const onStartDateChange = (val) => {
    const date = val ? dayjs(val.$d).format(dateFormat) : undefined;
    setTimes((prev) => {
      const prevDate =
        prev.endDate && dayjs(prev.endDate).isBefore(date)
          ? dayjs(date).format(dateFormat)
          : prev.endDate;
      return {
        ...prev,
        startDate: date,
        endDate: prevDate,
        times: calcDaysWorkingTimeArr(date, prevDate, prev.times)
      };
    });
    clearError("startDate");
  }; */
  const calcDaysWorkingTimeArr = (startDate, endDate, curTimesArr) => {
    if (!startDate || !endDate) return [];

    const date1 = dayjs(startDate);
    const date2 = dayjs(endDate);
    const daysCount = date2.diff(date1, "day");
    const defaultTimeObj = {
      startTime: undefined,
      endTime: undefined,
      date: undefined,
      timeRange: [undefined, undefined]
    };
    const newTimesArr = Array.from({ length: daysCount + 1 }, (_, i) => {
      const endTime = i === daysCount ? "16:00" : "18:00";

      return {
        ...defaultTimeObj,
        date: date1.add(i, "day").format("DD.MM"),
        timeRange: [
          dayjs(dayjs().format("YYYY-MM-DD 10:00")),
          dayjs(dayjs().format(`YYYY-MM-DD ${endTime}`))
        ]
      };
    });

    curTimesArr?.forEach((el, i) => {
      const endTime = i === daysCount ? "16:00" : "18:00";

      if (i < newTimesArr.length) {
        newTimesArr[i] = {
          ...newTimesArr[i],
          startTime: el.startTime,
          endTime: el.endTime,
          timeRange: [
            dayjs(dayjs().format(`YYYY-MM-DD ${el.startTime || "10:00"}`)),
            dayjs(dayjs().format(`YYYY-MM-DD ${el.endTime || endTime}`))
          ]
        };
      }
    });
    newTimesArr.forEach((el, i) => {
      const endTime = i === daysCount ? "16:00" : "18:00";
      if (formRef.current) {
        form.setFieldsValue({
          [`rangePicker_${i}`]: [
            dayjs(dayjs().format(`YYYY-MM-DD ${el.startTime || "10:00"}`)),
            dayjs(dayjs().format(`YYYY-MM-DD ${el.endTime || endTime}`))
          ]
        });
      }
    });
    return newTimesArr;
  };

  const navigate = useNavigate();

  const handleCloseModal = () => setModalType("");
  const handleOpenModal = (modalType) => setModalType(modalType);

  const renderSelectOptions = useMemo(
    () =>
      countries.map((country) => (
        <Select.Option key={country.id} value={country.id}>
          {t(country.name, { ns: "Countries" })}
        </Select.Option>
      )),
    [countries, t]
  );

  const handleIsVisible = ({ target: checked }) => {
    setCheckboxSelected((prevState) => ({
      ...prevState,
      isVisible: checked.checked,
      isPrivate: false
    }));
    form.setFieldsValue({ isPrivate: false });
    form.setFieldsValue({ isVisible: checked.checked });
  };

  const handleIsPrivate = ({ target: checked }) => {
    setCheckboxSelected((prevState) => ({
      ...prevState,
      isVisible: false,
      isPrivate: checked.checked
    }));
    form.setFieldsValue({ isPrivate: checked.checked });
    form.setFieldsValue({ isVisible: false });
  };

  const handleIsOnline = ({ target: checked }) => {
    setCheckboxSelected((prevState) => ({
      ...prevState,
      isOnline: checked.checked
    }));
    form.setFieldsValue({ isOnline: checked.checked });
  };

  const handleIsOnMain = async ({ target: checked }) => {
    setCheckboxSelected((prevState) => {
      return {
        ...prevState,
        isOnMain: checked.checked
      };
    });
    form.setFieldsValue({ isOnMain: checked.checked });
  };

  const handleIsAutomaticBannerChange = ({ target: checked }) => {
    setCheckboxSelected((prevState) => ({
      ...prevState,
      isAutomaticBannerChange: checked.checked
    }));
    form.setFieldsValue({ isAutomaticBannerChange: checked.checked });
  };

  const { OnlyLatinLettersTextInput, OnlyLatinLettersModal } =
    useOnlyLatinLetterInputHandlerAndModal();

  const handleCitiesSearch = async (name, customCountry) => {
    const countryIds = form.getFieldValue("countryId");
    if (!countryIds && !customCountry) return;
    const response = await resourcesAPI.getCities(name, customCountry || countryIds);
    return { data: response.data?.cities };
  };

  return (
    <>
      {OnlyLatinLettersModal}
      {modalType && (
        <Modal
          footer={null}
          visible={modalType}
          onOk={handleCloseModal}
          onCancel={handleCloseModal}
          className={s.modal}
        >
          {renderModalContent({
            modalType,
            t,
            handleCloseModal,
            isAdmin
          })}
        </Modal>
      )}

      <section
        id="create-exhibition"
        className={`${s.wrapper} ${isAdmin ? s.adminWrapper : ""}`}
        /* style={{ minWidth: !isEditMode ? 1581 : 1718 1004 }} */
      >
        <Form
          form={form}
          ref={formRef}
          labelAlign="left"
          autoComplete="off"
          scrollToFirstError
          onFinish={onFinish}
          onFinishFailed={({ errorFields }) => {
            clearAllErrors(errorFields);
            onFinish(form.getFieldsValue(), times);
          }}
          style={{ borderRight: "none" }}
          requiredMark={false}
          validateTrigger="onSubmit"
          name="addNewExhibitionForm"
        >
          <div>
            <div
              className={s.tableRow}
              style={{
                borderRight: "none",
                width: /* !isEditMode ? 1581 : 1754 1004 */ "100%",
                border: isAdmin && "none"
              }}
            >
              <div className={s.head}>
                <div className={`${s.cell} ${s.num} ${s.leftSide}`}>{num}</div>
                <div className={`${s.cell} ${s.premid}`}>{t("exhibitionName")}</div>
                <div className={`${s.cell} ${s.premid}`}>{t("website")}</div>
                <div className={`${s.cell} ${s.premid}`} style={{ width: 200 }}>
                  {t("table.countryAndCity", { ns: "BA1-EditAndViewExhibition" })}
                </div>
                <div className={`${s.cell} ${s.premid}`}>{t("areaName")}</div>
                <div className={`${s.cell} ${s.big}`}>
                  {t("table.startAndEndDate", { ns: "BA1-EditAndViewExhibition" })}
                </div>
                {/* <div className={`${s.cell} ${s.premid}`} style={{ width: 100 }}>
                  {t("endDate")}
                </div> */}
                <div
                  className={`${s.cell} ${s.premid}`}
                  style={{
                    width: /* (!isAdmin && !isEditMode && times.times.length > 0) ||
                      (!isAdmin && isEditMode) ||
                      times.times.length > 0
                        ? 300
                        : 160 */ 131
                  }}
                >
                  {t("times")}
                </div>
                <div className={`${s.cell} ${s.premid}`}>{t("companies1")}</div>
                <div
                  className={`${s.cell} ${s.premid}`}
                  style={{
                    width: /* (!isAdmin && !isEditMode && times.times.length > 0) ||
                      (!isAdmin && isEditMode) ||
                      times.times.length > 0
                        ? 223
                        : isAdmin
                        ? 228
                        : 214 */ 100
                  }}
                >
                  {t("moderationStatus")}
                </div>
              </div>

              <div className={s.tableBody}>
                <div className={`${s.cell2} ${s.leftSide}`}></div>
                <div className={`${s.cell2} ${s.premid} ${s.withDropDown}`}>
                  <Form.Item
                    name={"exhibitionName"}
                    rules={[
                      {
                        required: true,
                        message: ""
                      },
                      {
                        validator:
                          (!newExhibitionName && !exhibitionName) ||
                          (exhibitionName && !newExhibitionName),
                        message: ""
                      }
                    ]}
                  >
                    <AutoCompleteCustom
                      isError={Boolean(errors.exhibitionName)}
                      handleSelect={handleExhibitionSelect}
                      OnlyLatinLettersTextInput={OnlyLatinLettersTextInput}
                      form={form}
                      value={exhibitionName}
                      t={t}
                      setNewExhibitionName={setNewExhibitionName}
                      setErrors={setErrors}
                      errors={errors}
                      clearError={clearError}
                    />
                  </Form.Item>
                </div>
                <div className={`${s.cell2} ${s.premid}`}>
                  <Form.Item
                    className={s.formItem}
                    name={"website"}
                    rules={[
                      {
                        required: true,
                        message: ""
                      },
                      {
                        validator: (_, value) => {
                          const httpPattern = /^https?:\/\//;
                          const urlPattern =
                            /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([\/\w .-]*)*\/?(#.*)?$/;
                          if (!value || !httpPattern.test(value)) {
                            return Promise.reject(
                              t("websiteError", { ns: "FS8-changeCompanyProfile" })
                            );
                          }
                          if (!value || !urlPattern.test(value)) {
                            return Promise.reject(
                              t("webSiteUnCorrected", { ns: "FS8-changeCompanyProfile" })
                            );
                          } else {
                            return Promise.resolve();
                          }
                        }
                      }
                    ]}
                  >
                    <TextArea
                      className={`${s.TextArea} ${errors.website ? s.fieldError : ""}`}
                      placeholder={t("addExhibitionLink")}
                      onChange={(e) => {
                        setErrors((prev) => ({ ...prev, website: false }));
                        clearError("website");
                        OnlyLatinLettersTextInput(
                          e.target.value,
                          "website",
                          form,
                          true,
                          null,
                          null,
                          true
                        );
                      }}
                      style={{ minHeight: "119.6px", resize: "none" }}
                      disabled={isDisabled}
                    />
                  </Form.Item>
                </div>
                <div className={`${s.cell2} ${s.big} ${s.tableColumn}`} style={{ width: 200 }}>
                  <Form.Item
                    name={"countryId"}
                    rules={[
                      {
                        required: true,
                        message: ""
                      }
                    ]}
                  >
                    <Select
                      className={s.countrySelect}
                      style={{ width: "100%" }}
                      placeholder={t("selectCountry")}
                      onDropdownVisibleChange={(state) => {
                        form.setFields([{ name: "countryId", errors: [] }]);
                        setOpenState(state);
                      }}
                      onChange={(value) => {
                        form.setFieldsValue({ cityId: null });
                      }}
                      open={openState}
                      size="small"
                      suffixIcon={
                        <DropdownIcon
                          className={openState ? "ant-select-suffix" : ""}
                          onClick={() => setOpenState((prevState) => !prevState)}
                        />
                      }
                      disabled={isDisabled}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                      filterSort={(optionA, optionB) => {
                        return optionA.children
                          .toLowerCase()
                          .localeCompare(optionB.children.toLowerCase());
                      }}
                    >
                      {renderSelectOptions}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name={"cityId"}
                    rules={[
                      {
                        required: true,
                        message: ""
                      }
                    ]}
                  >
                    <DebounceSearchSelect
                      className={s.countrySelect}
                      search={handleCitiesSearch}
                      size="small"
                      style={{ width: "100%" }}
                      store={setCities}
                      disabled={isDisabled}
                      placeholder={t("selectCity")}
                      options={citiesOptions}
                      defaultValue={form.getFieldValue("cityId")}
                    />
                  </Form.Item>
                </div>
                <div className={`${s.cell2} ${s.premid}`}>
                  <Form.Item
                    name={"areaName"}
                    rules={[
                      {
                        required: true,
                        message: ""
                      }
                    ]}
                  >
                    <TextArea
                      className={`${s.TextArea} ${errors.areaName ? s.fieldError : ""}`}
                      placeholder={t("enterAreaName")}
                      autoSize={{
                        minRows: 4,
                        maxRows: 4
                      }}
                      style={{ minHeight: "119.6px", resize: "none" }}
                      onChange={(e) => {
                        setErrors((prev) => ({ ...prev, areaName: false }));
                        clearError("areaName");
                        OnlyLatinLettersTextInput(
                          e.target.value,
                          "areaName",
                          form,
                          true,
                          null,
                          null,
                          true
                        );
                      }}
                      disabled={isDisabled}
                    />
                  </Form.Item>
                </div>
                <div className={`${s.cell2} ${s.big} ${s.halfPaddingCell2}`}>
                  <Form.Item
                    name={["startDate"]}
                    rules={[
                      {
                        required: true,
                        message: "",
                        validator: (_, value) => {
                          if (value[0] && value[1] && value[0] > value[1]) {
                            return Promise.reject("End date must be after start date");
                          } else if (!value[0] || !value[1]) {
                            return Promise.reject("Please select both dates");
                          } else {
                            return Promise.resolve();
                          }
                        }
                      }
                    ]}
                  >
                    <RangePicker
                      className={s.datePicker}
                      disabled={isDisabled}
                      onChange={onStartDateChange}
                      format={"DD.MM.YYYY"}
                      placement="bottomRight"
                      showToday={false}
                    />
                  </Form.Item>
                </div>
                {/* <div className={`${s.cell2} ${s.premid}`} style={{ width: 100 }}>
                  <Form.Item
                    name={"startDate"}
                    rules={[
                      {
                        required: true,
                        message: ""
                      }
                    ]}
                  >
                    <DatePicker
                      className={s.datePicker}
                      onChange={onStartDateChange}
                      format={"DD.MM.YYYY"}
                      placement="bottomRight"
                      showToday={false}
                      disabledDate={(current) =>
                        (times.endDate && current > dayjs(times.endDate).endOf("day")) ||
                        (current && current < dayjs().startOf("day"))
                      }
                      disabled={isDisabled}
                    />
                  </Form.Item>
                </div>
                <div className={`${s.cell2} ${s.premid}`} style={{ width: 100 }}>
                  <Form.Item
                    name={"endDate"}
                    rules={[
                      {
                        required: true,
                        message: ""
                      }
                    ]}
                  >
                    <DatePicker
                      className={s.datePicker}
                      onChange={onEndDateChange}
                      format={"DD.MM.YYYY"}
                      placement="bottomRight"
                      showToday={false}
                      disabledDate={(current) => {
                        return (
                          (current &&
                            times.startDate &&
                            current < dayjs(times.startDate).startOf("day")) ||
                          (current && current < dayjs().startOf("day"))
                        );
                      }}
                      disabled={isDisabled}
                    />
                  </Form.Item>
                </div> */}
                <div
                  className={`${s.cell2} ${s.premid} ${s.timesRangeCell}`}
                  style={{
                    width: /* (!isAdmin && !isEditMode && times.times.length > 0) ||
                      (!isAdmin && isEditMode) ||
                      times.times.length > 0
                        ? 300
                        : 160 */ 131
                  }}
                >
                  {times.times.map((el, i) => (
                    <div key={`${el.date}_${i}`} className={"d-flex align-items-baseline"}>
                      {el.date}:
                      <Form.Item
                        name={`rangePicker_${i}`}
                        className={s.formItem}
                        rules={[
                          {
                            required: true,
                            message: ""
                          }
                        ]}
                      >
                        <TimePicker.RangePicker
                          className={s.datePicker}
                          placeholder={[t("startTime"), t("endTime")]}
                          format={"HH:mm"}
                          style={{ marginLeft: "5px" }}
                          minuteStep={5}
                          onCalendarChange={(val) => {
                            form.setFieldsValue({ [`rangePicker_${i}`]: val });
                            onWorkingTimeChange(val, i);
                          }}
                          value={[el?.timeRange?.[0], el?.timeRange?.[1]]}
                          disabled={isDisabled}
                        />
                      </Form.Item>
                    </div>
                  ))}
                </div>
                <div className={`${s.cell2} ${s.premid}`}>
                  {initialValues.statsUnconfirmedMeetings || 0}/
                  {initialValues.statsConfirmedMeetings || 0}
                </div>
                <div className={`${s.cell2} ${s.premid}`} style={{ width: 90 }}>
                  <div className={s.status}>
                    <span>
                      {t("editing", { ns: "CreateExhibitionPanel" })}
                      <Tooltip
                        placement="bottomLeft"
                        title={t("edited", { ns: "FS100-MyExhibitions" })}
                      >
                        <QuestionCircleOutlined
                          style={{
                            position: "relative",
                            cursor: "help",
                            alignSelf: "flex-start",
                            marginBottom: 7,
                            marginLeft: 5,
                            color: "#474747"
                          }}
                        />
                      </Tooltip>
                    </span>
                  </div>
                </div>
              </div>
              <div
                className={s.stand}
                style={{
                  /*minWidth: isAdmin
                    ? times.times.length > 0
                      ? 1889
                      : 1754
                    : times.times.length > 0 || isEditMode
                    ? 1775
                    : 1648 */
                  /* width: 1004 */
                  marginLeft: 16
                }}
              >
                <Row wrap={false} className={!isAdmin ? s.standTopRow : s.standTopRowAdmin}>
                  <div>
                    <div className="d-flex">
                      <div
                        style={{ height: 54, alignItems: "center" }}
                        className={`${s.cell} ${s.premid} ${s.stretchCell}`}
                      >
                        {t("exhibitionLogo")}
                      </div>
                    </div>
                    <div className="d-flex">
                      <div className={`${s.cell2} ${s.premid} ${s.stretchCell}`}>
                        <Form.Item
                          name={"logo"}
                          valuePropName="fileList"
                          getValueFromEvent={normalizeFile}
                        >
                          {logo ? (
                            <>
                              <ImagePreview
                                isOpen={logoPreviewOpen}
                                closePreview={closeLogoPreview}
                                openPreview={openLogoPreview}
                                imageUrl={`${logo}`}
                                alt="logo image"
                              />
                              {!isDisabled && (
                                <p
                                  className={"orange"}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => setLogo("")}
                                >
                                  {t("delete")}
                                </p>
                              )}
                            </>
                          ) : (
                            !isDisabled && (
                              <>
                                <Upload
                                  ref={uploadRef}
                                  maxCount={1}
                                  multiple={false}
                                  accept=".jpg,.jpeg,.png"
                                  beforeUpload={beforeLogoUpload}
                                  customRequest={(data) => uploadLogo(data)}
                                  showUploadList={false}
                                >
                                  <p className={`${s.uploadText} ${errors.logo ? s.error : ""}`}>
                                    {t("uploadSchema")}
                                  </p>
                                </Upload>
                              </>
                            )
                          )}
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  {!isAdmin && (
                    <div>
                      <div className="d-flex">
                        <div
                          style={{ height: 54, alignItems: "center" }}
                          className={`${s.cell} ${s.premid} ${!isAdmin ? s.stretchCell : ""}`}
                        >
                          {t("organizerName")}
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className={`${s.cell2} ${s.premid} ${!isAdmin ? s.stretchCell : ""}`}>
                          <Form.Item name={"organizerName"}>
                            <TextArea
                              className={`${s.TextArea} ${
                                errors.organizerName ? s.fieldError : ""
                              }`}
                              placeholder={t("enterOrganizerName")}
                              disabled={!canEditOrganizerName}
                              autoSize={{
                                minRows: 4,
                                maxRows: 4
                              }}
                              onChange={(e) => {
                                setErrors((prev) => ({ ...prev, organizerName: false }));
                                clearError("organizerName");
                                OnlyLatinLettersTextInput(
                                  e.target.value,
                                  "organizerName",
                                  form,
                                  true,
                                  null,
                                  null,
                                  true
                                );
                              }}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                  )}
                  {isAdmin && (
                    <div>
                      <div
                        style={{ height: 54, alignItems: "center" }}
                        className={`${s.exhibitionLogo} ${s.cell} ${s.mid} ${s.stretchCell}`}
                      >
                        {t("exhibitionBanners", { ns: "CreateExhibitionPanel" })}:
                      </div>
                      <div className={`${s.cell2} ${s.premid} ${s.stretchCell} ${s.halfPadding}`}>
                        <Form.Item name="banners" hidden></Form.Item>
                        <Upload
                          maxCount={3}
                          multiple
                          accept=".jpg,.jpeg,.png"
                          showUploadList={false}
                          beforeUpload={async (file, fileList) =>
                            await beforeUpload(file, "banners", fileList)
                          }
                          customRequest={(data) => uploadImg(data, "banners")}
                        >
                          {banners?.length < 3 && (
                            <p className={`${s.uploadText} ${errors.banners ? s.error : ""}`}>
                              {t("uploadSchemaBanners", { ns: "CreateExhibitionPanel" })}
                            </p>
                          )}
                        </Upload>
                        <div className={s.banners}>
                          {banners?.map((item) => (
                            <BannerPreview
                              key={item.name || item}
                              banner={item}
                              clearImage={clearImage}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                  {isAdmin && (
                    <div>
                      <div className="d-flex">
                        <div
                          style={{ height: 54, alignItems: "center" }}
                          className={`${s.cell} ${s.premid} ${s.stretchCell}`}
                        >
                          {t("organizerName")}
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className={`${s.cell2} ${s.premid} ${s.stretchCell}`}>
                          <Form.Item name={"organizerName"}>
                            <TextArea
                              className={`${s.TextArea} ${
                                errors.organizerName ? s.fieldError : ""
                              }`}
                              placeholder={t("enterOrganizerName")}
                              disabled={!canEditOrganizerName}
                              autoSize={{
                                minRows: 4,
                                maxRows: 4
                              }}
                              onChange={(e) => {
                                setErrors((prev) => ({ ...prev, organizerName: false }));
                                clearError("organizerName");
                                OnlyLatinLettersTextInput(
                                  e.target.value,
                                  "organizerName",
                                  form,
                                  true,
                                  null,
                                  null,
                                  true
                                );
                              }}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                  )}
                </Row>
                {!isAdmin && (
                  <div className={`${s.standLeft} ${s.standLeftStretch}`}>
                    <div>
                      <div className="d-flex">
                        <div
                          className={`${s.cell} ${s.premid} ${s.stretchCell}`}
                          style={{ height: 54, alignItems: "center" }}
                        >
                          {t("boothNumber")}:
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className={`${s.cell2} ${s.premid} ${s.stretchCell}`}>
                          <Form.Item name={"boothNumber"}>
                            <TextArea
                              className={`${s.TextArea} ${errors.boothNumber ? s.fieldError : ""}`}
                              placeholder={t("enterboothNumber")}
                              autoSize={{
                                minRows: 4,
                                maxRows: 4
                              }}
                              onChange={(e) => {
                                setErrors((prev) => ({ ...prev, boothNumber: false }));
                                clearError("boothNumber");
                                OnlyLatinLettersTextInput(
                                  e.target.value,
                                  "boothNumber",
                                  form,
                                  true,
                                  null,
                                  null,
                                  true
                                );
                              }}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div
                        style={{ height: 54, alignItems: "center" }}
                        className={`${s.cell} ${s.premid} ${s.stretchCell}`}
                      >
                        {t("schemaToStand")}
                      </div>
                      <div className={`${s.cell2} ${s.premid} ${s.stretchCell}`}>
                        <Form.Item
                          name={"passageDiagram"}
                          valuePropName="fileList"
                          getValueFromEvent={normalizeFile}
                        >
                          {passageDiagram ? (
                            <>
                              <ImagePreview
                                isOpen={imagePreviewOpen}
                                closePreview={closeImagePreview}
                                openPreview={openImagePreview}
                                imageUrl={`${passageDiagram}`}
                              />
                              <p
                                className={"orange"}
                                style={{ cursor: "pointer" }}
                                onClick={() => setPassageDiagram("")}
                              >
                                {t("delete")}
                              </p>
                            </>
                          ) : (
                            <>
                              <Upload
                                ref={uploadRef}
                                maxCount={1}
                                multiple={false}
                                accept=".jpg,.jpeg,.png"
                                beforeUpload={beforeUpload}
                                customRequest={(data) => uploadImg(data, "passageDiagram")}
                                showUploadList={false}
                              >
                                <p
                                  className={`${s.uploadText} ${
                                    errors.passageDiagram ? s.error : ""
                                  }`}
                                >
                                  {t("uploadSchema")}
                                </p>
                              </Upload>
                            </>
                          )}
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                )}
                <div
                  className={`${s.standRight} ${s.standRightAuto}`}
                  style={
                    {
                      /* width:
                      (!isEditMode && times.times.length > 0) ||
                      isEditMode ||
                      times.times.length > 0
                        ? "85.7%"
                        : "83.3%" */
                    }
                  }
                >
                  <div
                    className={`${s.controls} ${s.big}`}
                    style={{ width: !isAdmin ? 170 : times.times.length > 0 ? 167 : 172 }}
                  >
                    <div className={s.checkboxes}>
                      {!isAdmin ? (
                        <>
                          <Form.Item
                            name={"isVisible"}
                            valuePropName="checked"
                            rules={[
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  const isPrivate = getFieldValue("isPrivate");
                                  if (!Boolean(value) && isPrivate) {
                                    setCheckboxError(false);
                                    return Promise.resolve();
                                  } else if (Boolean(value) && !isPrivate) {
                                    setCheckboxError(false);
                                    return Promise.resolve();
                                  } else if (Boolean(value)) {
                                    setCheckboxError(false);
                                    return Promise.resolve();
                                  } else if (exhibitionId) {
                                    setCheckboxError(false);
                                    return Promise.resolve();
                                  } else {
                                    return Promise.resolve();
                                    /* return Promise.reject(); */
                                  }
                                }
                              })
                            ]}
                          >
                            <Space>
                              <Checkbox
                                className={`small ${
                                  isDisabled || checkBoxSelected.isVisible
                                    ? "ant-checkbox-checked"
                                    : ""
                                }`}
                                style={{ borderColor: "red" }}
                                defaultChecked={isDisabled || Boolean(initialValues.isVisible)}
                                checked={checkBoxSelected.isVisible}
                                ariaChecked="isVisible"
                                disabled={isDisabled}
                                onChange={handleIsVisible}
                              />
                              <span>{t("isVisible")}</span>
                              <Tooltip
                                placement="bottomLeft"
                                title={isDisabled ? t("visibility_v2") : t("visibility")}
                              >
                                <QuestionCircleOutlined
                                  style={{
                                    position: "relative",
                                    cursor: "help",
                                    alignSelf: "end",
                                    marginBottom: 0,
                                    color: "#474747",
                                    marginLeft: "auto"
                                  }}
                                />
                              </Tooltip>
                            </Space>
                          </Form.Item>
                          <Form.Item
                            className={s.formItem}
                            name={"isPrivate"}
                            valuePropName="checked"
                            rules={[
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  const isVisible = getFieldValue(["isVisible"]);

                                  if (!Boolean(value) && isVisible) {
                                    setCheckboxError(false);
                                    return Promise.resolve();
                                  } else if (Boolean(value) && !isVisible) {
                                    setCheckboxError(false);
                                    return Promise.resolve();
                                  } else if (Boolean(value)) {
                                    setCheckboxError(false);
                                    return Promise.resolve();
                                  } else if (exhibitionId) {
                                    setCheckboxError(false);
                                    return Promise.resolve();
                                  } else {
                                    return Promise.resolve();
                                    /* setCheckboxError(false);
                                  return Promise.reject(); */
                                  }
                                }
                              })
                            ]}
                          >
                            <Space>
                              <Checkbox
                                className={`small ${
                                  checkBoxSelected.isPrivate ? "ant-checkbox-checked" : ""
                                }`}
                                style={{ borderColor: "red" }}
                                defaultChecked={initialValues.isPrivate}
                                checked={checkBoxSelected.isPrivate}
                                ariaChecked="isPrivate"
                                disabled={isDisabled}
                                onChange={handleIsPrivate}
                              />
                              <span>{t("isPrivate")}</span>
                              <Tooltip
                                placement="bottomLeft"
                                title={isDisabled ? t("private_v2") : t("private")}
                              >
                                <QuestionCircleOutlined
                                  style={{
                                    position: "relative",
                                    cursor: "help",
                                    alignSelf: "end",
                                    marginBottom: 0,
                                    color: "#474747"
                                  }}
                                />
                              </Tooltip>
                            </Space>
                          </Form.Item>
                        </>
                      ) : (
                        <>
                          <Form.Item
                            className={s.formItem}
                            name={"isAutomaticBannerChange"}
                            valuePropName="checked"
                          >
                            <Space>
                              <Checkbox
                                className={`small ${
                                  checkBoxSelected.isAutomaticBannerChange
                                    ? "ant-checkbox-checked"
                                    : ""
                                }`}
                                defaultChecked={initialValues.isAutomaticBannerChange}
                                checked={checkBoxSelected.isAutomaticBannerChange}
                                ariaChecked="isAutomaticBannerChange"
                                disabled={isDisabled}
                                onChange={handleIsAutomaticBannerChange}
                              />
                              <span>Автоматическая смена баннеров</span>
                            </Space>
                          </Form.Item>
                          <Form.Item
                            className={s.formItem}
                            name={"isOnMain"}
                            valuePropName="checked"
                          >
                            <Space>
                              <Checkbox
                                className={`small ${
                                  checkBoxSelected.isOnMain ? "ant-checkbox-checked" : ""
                                }`}
                                defaultChecked={initialValues.isOnMain}
                                checked={checkBoxSelected.isOnMain}
                                ariaChecked=""
                                onChange={handleIsOnMain}
                              />
                              <span>Показывать на главной странице</span>
                            </Space>
                          </Form.Item>
                        </>
                      )}
                      <Form.Item className={s.formItem} name={"isOnline"} valuePropName="checked">
                        <Space>
                          <Checkbox
                            className={`small ${s.orangeCheckbox} ${
                              checkBoxSelected.isOnline ? "ant-checkbox-checked" : ""
                            }`}
                            defaultChecked={initialValues.isOnline}
                            checked={checkBoxSelected.isOnline}
                            ariaChecked="isOnline"
                            disabled={isDisabled || !isAdmin}
                            onChange={handleIsOnline}
                          />
                          <span className={s.orange}>{t("Online")}</span>
                        </Space>
                      </Form.Item>
                    </div>
                    {validateCheckBox && checkboxError && (
                      <p style={{ marginLeft: "20px", marginBottom: "25px", color: "#ff4d4f" }}>
                        {t("visibleStand")}
                      </p>
                    )}
                    <div
                      className={s.actions}
                      style={
                        isAdmin
                          ? {
                              /* width:
                          times.times.length > 0
                            ? "136%"
                            : isAdmin && times.times.length < 0
                            ? "132%"
                            : "122%", */
                              justifyContent: "center",
                              gap: 20
                            }
                          : {
                              marginTop: "3%"
                            }
                      }
                    >
                      <div className={s.wrap}>
                        {/* <Tooltip
                          placement="bottomLeft"
                          title={isAdmin ? t("saveTheExhibition") : t("saveAndContinue")}
                        >
                          <button
                            className={s.saveBtn}
                            type={isAdmin ? "button" : "submit"}
                            onClick={() => {
                              if (isAdmin) {
                                form
                                  .validateFields()
                                  .then((data) => {
                                    onFinish(data);
                                  })
                                  .catch(({ errorFields }) => {
                                    handleErrors(errorFields);
                                  });
                              }
                            }}
                          >
                            S
                          </button>
                        </Tooltip> */}
                        {/* {!isAdmin && (
                          <Tooltip placement="left" title={t("sendModerationBtn")}>
                            <span
                              className={s.moderate}
                            >
                              M
                            </span>
                          </Tooltip>
                        )} */}
                        <Tooltip title={t("clear")}>
                          <span>
                            <Trash
                              stroke={"#222222"}
                              onClick={() => {
                                clearForm();
                                deleteDraft();
                                dispatch(setSavedExhibition(null));
                                dispatch(setIsExistExhibitions([]));
                                dispatch(setExistExhibitionsArchive([]));
                                clearImage();
                                clearLogoImage();
                                setCities([]);
                                setExhibitionName("");
                                setNewExhibitionName("");
                                setExhibitionId(null);
                                setCheckboxError(false);
                                setCheckboxSelected({ isVisible: false, isPrivate: false });
                                setIsCreating(true);
                                setValidateCheckBox(false);
                              }}
                            />
                          </span>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {!isAdmin && (
                <Flex style={{ marginLeft: 16 }}>
                  <div className={`${s.cell} ${s.premid} ${s.bottomCell}`}>
                    {t("descriptionTitle")}
                  </div>
                  <Form.Item
                    className={`${s.formItem} ${s.bottomFormItem}`}
                    name={"description"}
                    rules={[
                      {
                        required: true,
                        message: ""
                      }
                    ]}
                  >
                    <TextArea
                      showCount={{ formatter: (value) => countFormatter(value, t) }}
                      autoSize={{
                        minRows: 5,
                        maxRows: 8
                      }}
                      style={{ padding: "24px 16px 0px 16px" }}
                      onChange={(e) => {
                        setErrors((prev) => ({ ...prev, description: false }));
                        clearError("description");
                        OnlyLatinLettersTextInput(
                          e.target.value,
                          "description",
                          form,
                          true,
                          /[^a-z\s\d-@,.?!_/:;’©®™°…‾´<>±⁄≤≥≈€¢£$•&«»″*–—#%+=()'"^\[\]]/gi,
                          null,
                          true
                        );
                      }}
                      className={`${s.TextArea}`}
                      placeholder={t("description")}
                      maxLength={1000}
                    />
                  </Form.Item>
                </Flex>
              )}
              {!isAdmin && (
                <Flex style={{ marginLeft: 16 }}>
                  <div className={`${s.cell} ${s.premid} ${s.bottomCell}`}>
                    {t("participantDescription")}
                  </div>
                  <Form.Item
                    className={`${s.formItem} ${s.bottomFormItem}`}
                    name={"participationDescription"}
                    rules={[
                      {
                        required: true,
                        message: t("fields.participationDescription.errors.required", {
                          ns: "FS10-AddNewProduct"
                        })
                      }
                    ]}
                  >
                    <TextArea
                      showCount={{ formatter: (value) => countFormatter(value, t) }}
                      autoSize={{
                        minRows: 5,
                        maxRows: 8
                      }}
                      style={{ padding: "24px 16px 0px 16px" }}
                      onChange={(e) => {
                        setErrors((prev) => ({ ...prev, participationDescription: false }));
                        clearError("participationDescription");
                        OnlyLatinLettersTextInput(
                          e.target.value,
                          "participationDescription",
                          form,
                          true,
                          /[^a-z\s\d-@,.?!_/:;’©®™°…‾´<>±⁄≤≥≈€¢£$•&«»″*–—#%+=()'"^\[\]]/gi,
                          null,
                          true
                        );
                      }}
                      className={`${s.TextArea}`}
                      placeholder={t("description")}
                      maxLength={1000}
                    />
                  </Form.Item>
                </Flex>
              )}
              {isAdmin ? (
                <>
                  <Flex style={{ marginLeft: 16 }} className={s.bottomEditorRow}>
                    <div className={`${s.cell} ${s.premid} ${s.bottomCell}`}>
                      {t("mainDescriptionTitle")}
                    </div>
                    <div className={s.bottomEditor}>
                      <Form.Item name="mainPageDescriptionGrey" hidden>
                        <Input />
                      </Form.Item>
                      <Editor
                        className={s.editor}
                        inline_styles={true}
                        apiKey={TINY_MCE_API_KEY}
                        plugins={["code"]}
                        value={mainPageDescriptionGrey}
                        init={{
                          relative_urls: false,
                          remove_script_host: false,
                          document_base_url: PRODUCTION_URL
                        }}
                        onEditorChange={(content, editor) =>
                          handleEditorChange(content, editor, "mainPageDescriptionGrey")
                        }
                      />
                    </div>
                  </Flex>
                  <Flex style={{ marginLeft: 16 }} className={s.bottomEditorRow}>
                    <div
                      className={`${s.cell} ${s.premid} ${s.bottomCell} ${s.orangeDescriptionTitle}`}
                    >
                      {t("mainDescriptionTitle")}
                    </div>
                    <div className={s.bottomEditor}>
                      <Form.Item name="mainPageDescriptionOrange" hidden>
                        <Input />
                      </Form.Item>
                      <Editor
                        className={s.editor}
                        inline_styles={true}
                        apiKey={TINY_MCE_API_KEY}
                        plugins={["code"]}
                        value={mainPageDescriptionOrange}
                        init={{
                          relative_urls: false,
                          remove_script_host: false,
                          document_base_url: PRODUCTION_URL
                        }}
                        onEditorChange={(content, editor) =>
                          handleEditorChange(content, editor, "mainPageDescriptionOrange")
                        }
                      />
                    </div>
                  </Flex>
                  <Flex style={{ marginLeft: 16 }}>
                    <div className={`${s.cell} ${s.premid} ${s.bottomCell}`}>
                      {t("publicDescriptionTitle")}
                    </div>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: ""
                        }
                      ]}
                      className={`${s.formItem} ${s.bottomFormItem}`}
                      name={"description"}
                    >
                      <TextArea
                        showCount={{ formatter: (value) => countFormatter(value, t) }}
                        autoSize={{
                          minRows: 2,
                          maxRows: 8
                        }}
                        style={{ padding: "24px 16px 0px 16px" }}
                        onChange={(e) => {
                          setErrors((prev) => ({ ...prev, description: false }));
                          clearError("description");
                          OnlyLatinLettersTextInput(
                            e.target.value,
                            "description",
                            form,
                            true,
                            /[^a-z\s\d-@,.?!_/:;’©®™°…‾´<>±⁄≤≥≈€¢£$•&«»″*–—#%+=()'"^\[\]]/gi,
                            null,
                            true
                          );
                        }}
                        className={`${s.TextArea}`}
                        placeholder={t("description")}
                        maxLength={1000}
                      />
                    </Form.Item>
                  </Flex>
                  <Modal
                    width={680}
                    visible={showErrorModal}
                    onCancel={() => setShowErrorModal(false)}
                    footer={[
                      <Button
                        className={`btn btn_v2`}
                        key={1}
                        onClick={() => setShowErrorModal(false)}
                      >
                        ОК
                      </Button>
                    ]}
                  >
                    <p>{modalText}</p>
                  </Modal>
                </>
              ) : (
                <>
                  <Flex style={{ marginLeft: 16 }}>
                    <div className={`${s.cell} ${s.premid} ${s.bottomCell}`}>{t("keywords")}</div>
                    <Form.Item
                      className={`${s.formItem} ${s.bottomFormItem}`}
                      name={"keyProducts"}
                      rules={[
                        {
                          required: true,
                          message: ""
                        },
                        customKeyWordsValidator(form, t, 10, "keyProducts")
                      ]}
                    >
                      <TextArea
                        showCount={{ formatter: () => t("keyProductsPlaceholder") }}
                        autoSize={{
                          minRows: 2,
                          maxRows: 8
                        }}
                        style={{ padding: "24px 16px" }}
                        onChange={(e) => {
                          setErrors((prev) => ({ ...prev, keyProducts: false }));
                          clearError("keyProducts");
                          OnlyLatinLettersTextInput(
                            e.target.value,
                            "keyProducts",
                            form,
                            true,
                            null,
                            null,
                            true
                          );
                        }}
                        className={`${s.TextArea}`}
                        placeholder={t("keyProductsPlaceholder")}
                      />
                    </Form.Item>
                  </Flex>
                </>
              )}
              <Row align="center" className={s.actions}>
                <Button
                  className={`${s.actionBtn} ${s.save} btn btn_v2`}
                  type={isAdmin ? "button" : "submit"}
                  htmlType={isAdmin ? "button" : "submit"}
                  style={{ width: "100%" }}
                  onClick={() => {
                    if (isAdmin) {
                      form
                        .validateFields()
                        .then((data) => {
                          onFinish(data);
                        })
                        .catch(({ errorFields }) => {
                          handleErrors(errorFields);
                        });
                    }
                  }}
                >
                  {t("saveAndContinueEditing", { ns: "FS100-MyExhibitions" })}
                </Button>
                {!isAdmin && (
                  <Button
                    type="default"
                    onClick={async () => {
                      const isFree = newExhibitionName
                        ? await isExhibitionNameFree(newExhibitionName)
                        : true;
                      setValidateCheckBox(true);
                      form
                        .validateFields()
                        .then((data) => {
                          console.log(data);
                          if (isFree || !isCreating) {
                            const sendData = normalizeExhibitionData(data);
                            if (exhibitionNameAnreadyExsist && !isDisabled) {
                              setModalText(t("infoModal.errorExhibitionAlreadyExist"));
                              setShowErrorModal(true);
                            } else if (standAlreadyExsist) {
                              handleOpenModal(modalTypes.STAND_EXISTS);
                            } else {
                              const formValues = form.getFieldsValue();
                              navigate("/account/exhibition-preview", {
                                state: {
                                  exhibition: {
                                    ...sendData,
                                    stand: {
                                      ...sendData?.stand
                                    }
                                  },
                                  isNewExhibition: exhibitionName === sendData?.exhibitionName,
                                  isPrivate: checkBoxSelected.isPrivate,
                                  isVisible: checkBoxSelected.isVisible,
                                  formValues: { ...formValues, passageDiagram, logo },
                                  times,
                                  isCreating,
                                  type: "create"
                                }
                              });
                            }
                          } else {
                            setModalText(t("infoModal.errorExhibitionAlreadyExist"));
                            setShowErrorModal(true);
                          }
                        })
                        .catch(({ errorFields }) => {
                          handleErrors(errorFields);
                          scrollToFirstInvalidFiled();
                        });
                    }}
                    className={`${s.actionBtn} btn btn_v8 ant-btn-lg`}
                  >
                    {t("preview", { ns: "FS100-MyExhibitions" })}
                  </Button>
                )}
              </Row>
            </div>
          </div>
        </Form>
      </section>
    </>
  );
};

const renderModalContent = ({ modalType, t, handleCloseModal, clearForm, isAdmin }) => {
  const modalContent = {
    UNKNOWN_ERROR: <p style={{ marginTop: 0, width: 475 }}>{t("infoModal.unknownError")}</p>,
    CREATION_SUCCESS: <p style={{ marginTop: 0, width: 290 }}>{t("infoModal.creation_success")}</p>,
    SAVING_SUCCESS: isAdmin ? (
      <div className={s.saved_modal}>
        <h2>{t("infoModal.finishEditingAdmin1")}</h2>
        <p>{t("infoModal.finishEditingAdmin2")}</p>
        <Button className="btn btn_v2" onClick={handleCloseModal}>
          OK
        </Button>
      </div>
    ) : (
      <div className={s.saved_modal}>
        <h3>{t("saved")}</h3>
        <p>{t("instruction")}</p>
        <Button className="btn btn_v2" onClick={handleCloseModal}>
          OK
        </Button>
      </div>
    ),
    FINISH_EDITING: (
      <div className={s.modal_finishModal}>
        <h2>{t("infoModal.finishEditing1")}</h2>
        <p>{t("infoModal.finishEditing2")}</p>
        <Button className="btn btn_v2">{t("infoModal.previewBtn")}</Button>
      </div>
    ),
    EXHIBITION_ALREADY: (
      <div className={s.modal_exist}>
        {/* TODO: styling */}
        <p style={{ marginTop: 10, width: 520 }}>
          {t("infoModal.existAlready1")}
          <Link
            to={"/admin-panel/edit-and-view-exhibition"}
            target="_blank"
            onClick={() => {
              handleCloseModal();
              clearForm();
            }}
            className={s.adminLink}
          >
            {t("infoModal.existAlready2")}
          </Link>
        </p>
      </div>
    ),
    WRONG_NEW_EXHIBITION_OR_EXHIBITION_ID: "WRONG_NEW_EXHIBITION_OR_EXHIBITION_ID",
    STAND_EXISTS: (
      <div className={s.modal_exist}>
        <p style={{ marginTop: 0, width: 520 }}>{t("infoModal.standExhist")}</p>
        <Button key="ok" className="btn btn_v2" onClick={handleCloseModal}>
          OK
        </Button>
      </div>
    ),
    TOO_MANY_ON_MAIN: (
      <div className={s.modal_exist}>
        <p style={{ marginTop: 0, width: 520 }}>
          {t("modalErrors.TOO_MANY_ON_MAIN", { ns: "FS100-MyExhibitions" })}
        </p>
        <Button key="ok" className="btn btn_v2" onClick={handleCloseModal}>
          OK
        </Button>
      </div>
    ),
    NOT_FOUND_EXHIBITION: "NOT_FOUND_EXHIBITION",
    NO_CORRECT_TIMES: "NO_CORRECT_TIMES",
    isPrivate: (
      <div className={s.isPrivate}>
        <h3>{t("dearUser", { ns: "FA52A-Moderation-changes" })}</h3>
        <p>{t("isPrivate_modal.text1")}</p>
        <p>{t("isPrivate_modal.text2")}</p>
        <p>{t("isPrivate_modal.text3")}</p>
        {!isAdmin && (
          <p>
            {t("isPrivate_modal.text4")}{" "}
            <Link to={"/account/make-complaint"} state={{ isExhibition: true }}>
              {t("isPrivate_modal.link")}
            </Link>{" "}
          </p>
        )}
        <Button key="ok" className="btn btn_v2" onClick={handleCloseModal}>
          OK
        </Button>
      </div>
    ),
    isArchive: (
      <div className={s.isPrivate}>
        <p style={{ marginTop: 0, width: 520, fontWeight: 500 }}>{t("isArchive_modal")}</p>
        <Button key="ok" className="btn btn_v2" onClick={handleCloseModal}>
          OK
        </Button>
      </div>
    ),
    onModeration: (
      <div className={s.isPrivate}>
        <p style={{ marginTop: 0, width: 575, fontWeight: 500 }}>{t("onModeration")}</p>
        <Button key="ok" className="btn btn_v2" onClick={handleCloseModal}>
          OK
        </Button>
      </div>
    )
  };

  return modalContent[modalType] || null;
};
CreateExhibitionPanel.propTypes = {
  num: PropTypes.number,
  showCreateExhibitionPanel: PropTypes.bool,
  fetchData: PropTypes.func,
  closePanel: PropTypes.func
};
export default React.memo(CreateExhibitionPanel);
